import { SearchBar } from 'antd-mobile'
import React, { useEffect, useRef, useState } from 'react'
import './css/publish.css'
import general, { redux } from '../../../../../general'
import Dialog from '../../../../../lib/Dialog'

export default function SelectGame(props) {

  const [list, setList] = useState([])
  const ref = useRef()

  const pitchelectlist = () => {
    Dialog.loading()
    general.axios.post('/pitchelectlist', {
      game_name: ref.current.nativeElement.value,
      pagination: {
        page: 1,
        count: 999998
      }
    })
      .finally(() => {
        Dialog.close()
      })
      .then(res => {
        const { status, data: { recent_viewed, game_list } } = res.data
        if (status.succeed) {
          if (ref.current.nativeElement.value.length > 0) {
            setList([
              { items: game_list }
            ])
          } else {
            setList([
              { title: '看过的游戏/圈子', items: recent_viewed },
              { title: '热门推荐', items: game_list }
            ])
          }
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    if (props.active) {
      pitchelectlist()
    }
  }, [props.active])

  return (
    <div className='select-game-index'>
      <div className='select-game-container'>
        <div className='select-game-header'>
          <SearchBar
            className='search-bar'
            ref={ref}
            onSearch={pitchelectlist}
            placeholder='搜索想要的游戏/圈子'
            searchIcon={<img style={{ position: 'relative', top: '-1.5px' }} src='/resources/user/ss.png' alt='' height={14} />}
            onlyShowClearWhenFocused={true}
            style={{
              '--height': '40px',
              '--padding-left': '10px',
              overflow: 'hidden',
            }}
          ></SearchBar>
          <div className='search-button' onClick={pitchelectlist}>搜索</div>
        </div>
        <div className="select-games">
          {list.map((item, index) => {
            return <div className='game-item' key={index}>
              {item.title && <div className="item-header">{item.title}</div>}
              <div className="item-games">
                {item.items.map((game, gindex) => {
                  return <div className='item' key={gindex} onClick={() => {
                    redux.dispatch({
                      type: 'community_selectgame',
                      data: {
                        community_selectgame: game
                      }
                    })
                    general.history.goBack()
                  }}>
                    <div className="icon">
                      <img src={game.game_image.thumb} alt="" />
                    </div>
                    <div className="info">
                      <div className="name">{game.game_name}</div>
                      <div className="desc">{game.description}</div>
                    </div>
                  </div>
                })}
              </div>
            </div>
          })}
        </div>
      </div>
    </div>
  )
}
